export default {
    
    /**
     * Call to the back for validate the current step
     * 
     * @param {Object} formData data to validate
     * @param {'needs'|'credentials'|'account'} endpoint
     * @param {*} params to pass in query
     * @return {promise}
     */
    validateStep(formData, endpoint, params = {}) {
        return new Promise((resolve, reject) => {
            SellsyJS.WebServiceCaller.post(`/onboarding/trial/${endpoint}`, params, formData, 
                res => resolve(res),
                err => reject(err.response.data.error.message)
            );
        })
    },

    /**
     * Call to the back for know if account is activated
     *
     * @param {*} params 
     */
    isActiveAccount(params = {}) {
        return new Promise((resolve, reject) => {
            SellsyJS.WebServiceCaller.get(`/onboarding/trial/activation`, params, 
                res => resolve(res),
                err => reject(err.response.data.error.message)
            );
        }) 
    },

    /**
     * Call to the back to retrieve the list of needs
     * 
     * @param {*} ressources 
     * @param {*} params 
     */
    findAll(ressources, params = {}) {
        return new Promise((resolve, reject) => {
            SellsyJS.WebServiceCaller.get(`/onboarding/${ressources}`, params, 
                res => resolve(res),
                err => reject(err.response.data.error.message)
            );
        })     
    }
}